import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { submit, arrayPush, formValueSelector, arrayInsert, arrayRemove } from 'redux-form';
import { isEmpty, get, filter, map, find } from 'lodash';
import classnames from 'classnames';
import { Helpers } from 'shared-components/helpers/helpers';
import { fetchBooking, resetBookingStore } from '../../app-main/actions/booking';
import {
  fetchInventory,
  storeInventoryItem,
  deleteInventoryItem,
  resetInventoryStore
} from '../../app-main/actions/inventory';
import { fetchEnvAddOns, fetchEnvWeb, resetEnvStore } from '../../app-main/actions/env';
import { fetchContractsSnapshot } from '../../app-main/actions/contracts';
import { fetchAllFeeProfiles } from '../../app-main/actions/feeProfile';
import { updateAddOnsStep, updateAddOnsIndex } from '../../app-main/actions/add-ons';
import { updatePayload } from '../../app-main/actions/payload';
import CustomOfferMain from '../../app-bookings-custom/custom-offer-main';
import { PageSpinner } from 'shared-components/decorators/spinner';
import { toggleBanner } from '../../app-main/actions/banner';
import {
  ADD_ITEM_FORM,
  ADD_ITEMS_FORM,
  CREATE_ITEM_FORM,
  ADDTL_TAX_FEES_FORM
} from '../components/reduxForms/constants/formNames';

class CustomOfferContainer extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isEditOffer: false,
      isHostUpdate: false,
      showAddOnsPanel: true,
      whichModal: '',
      isVatEnabled: false
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.createItem = this.createItem.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.openModal = this.openModal.bind(this);
    this.addAddtlTaxorFee = this.addAddtlTaxorFee.bind(this);
    this.addItem = this.addItem.bind(this);
    this.getInventoryItem = this.getInventoryItem.bind(this);
    this.editBookingAddOn = this.editBookingAddOn.bind(this);
    this.openEditBookingAddOnModal = this.openEditBookingAddOnModal.bind(this);
    this.navigateBack = this.navigateBack.bind(this);
    this.redirectToInboxDetails = this.redirectToInboxDetails.bind(this);
    this.updatePayloadBookingDetails = this.updatePayloadBookingDetails.bind(this);
    this.updatePayloadAddOns = this.updatePayloadAddOns.bind(this);
    this.closePanel = this.closePanel.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
    this.handleBreadcrumbClick = this.handleBreadcrumbClick.bind(this);
  }

  componentWillUnmount () {
    const { dispatch } = this.props;
    dispatch(resetInventoryStore());
    dispatch(resetBookingStore());
    dispatch(resetEnvStore());
  }

  async componentDidMount () {
    const { dispatch, routeParams, accessToken, isEdit, isHostUpdate, location } = this.props;
    const bookingId = get(routeParams, 'id') || this.props.bookingId;
    const path = get(location, 'pathname', null);
    const lastParam = path ? path.substr(path.lastIndexOf('/') + 1) : null;

    dispatch(fetchEnvAddOns());
    dispatch(fetchEnvWeb());

    if (accessToken) {
      dispatch(fetchBooking(bookingId, accessToken, response => {
        const spaceId = get(response, 'space_id');

        const vatEnabledCountries = (
          window.vat_launched_countries_hash || ''
        ).split(' ');
        const listingCountry = get(response, 'listing.country');
        const isVatEnabled = vatEnabledCountries.includes(listingCountry);

        dispatch(fetchInventory(spaceId, accessToken));

        if (isVatEnabled) {
          const bookingHostId = get(response, 'host_id');
          dispatch(fetchAllFeeProfiles(accessToken, bookingHostId))
        }

        this.setState({
          isVatEnabled
        });
      }));
    }

    this.setState({
      isEditOffer: isEdit || 'edit-offer' === lastParam,
      isHostUpdate: isHostUpdate || 'host-update-booking' === lastParam
    });

    await dispatch(fetchContractsSnapshot(bookingId, accessToken, response => {
      if (200 === response.statusCode) {
        this.updatePayloadBookingDetails(response.contracts);
      }
    }));

    return dispatch(updateAddOnsStep(1));
  }

  componentWillReceiveProps (nextProps) {
    const { profile, booking } = nextProps;
    const bookingHostID = _.get(booking, 'booking.host_id');

    // only booking host can access custom offer form
    if (bookingHostID && !profile.isFetching && (bookingHostID !== profile.SSOid)) {
      window.location.href = '/inbox';
    }
  }

  onModalClose () {
    const { dispatch } = this.props;
    dispatch(updateAddOnsIndex(null));
    this.toggleModal();
  }

  getInventoryItem (itemId) {
    const inventoryItems = get(this.props.inventory, 'data.inventory');
    const inventoryItem = find(inventoryItems, { _id: itemId });

    const item = {
      ...inventoryItem,
      description: inventoryItem.description || null,
      additional_charges: inventoryItem.additional_charges || []
    };

    this.props.dispatch(storeInventoryItem(item));
  }

  toggleModal (whichModal) {
    this.setState({ whichModal });
  }

  updatePayloadAddOns (payloadObj) {
    const { dispatch, snapshotContracts, payloadData } = this.props;
    const contracts = !isEmpty(snapshotContracts.pending) ? snapshotContracts.pending : snapshotContracts.contracts;
    const contractItems = filter(contracts, { type: 'ITEM' });
    const payloadItems = filter(payloadData.items, { type: 'ITEM' });

    // add items from current payload before adding from contract
    let addOns = payloadItems;
    if (_.isEmpty(payloadItems)) {
      addOns = map(contractItems, item => {
        const unitCost = get(item, 'meta.unit_cost', null);

        return {
          type: item.type,
          info: {
            item_id: item.item_id,
            custom_price: item.custom_price || unitCost,
            count: item.units
          }
        };
      });
    }

    const payload = {
      ...payloadObj,
      items: [
        ...payloadObj.items,
        ...addOns
      ]
    };

    dispatch(updatePayload(payload));
  }

  updatePayloadBookingDetails (contracts) {
    const spaceRental = find(contracts, { type: 'SPACE_RENTAL' });
    const spaceRentalBooking = _.get(spaceRental, 'meta.booking', {});

    const {
      _id,
      host_id,
      guest_id,
      number_of_guests,
      addtl_charges,
      subtotal_amount,
      schedule
    } = spaceRentalBooking;

    const addtl_charge_lis = map(addtl_charges, (charge, index) => {
      return {
        index,
        update: {
          ...charge
        }
      };
    });

    const payload = {
      booking_id: _id,
      host_sso_id: host_id,
      guest_sso_id: guest_id,
      type: 'OFFER',
      items: [
        {
          type: 'BOOKING',
          info: {
            schedule,
            number_of_guests,
            addtl_charge_lis,
            custom_subtotal_amount: subtotal_amount
          }
        }
      ]
    };

    this.props.dispatch(updatePayload(payload));
  }

  createItem () {
    const { dispatch } = this.props;

    dispatch(submit(CREATE_ITEM_FORM));
  }

  deleteItem () {
    const itemId = get(this.props, 'inventory.item._id');
    const spaceId = get(this.props, 'inventory.item.space_id');
    const token = get(this.props, 'accessToken');

    this.props.dispatch(deleteInventoryItem(itemId, token))
      .then(() => this.props.dispatch(fetchInventory(spaceId, token)))
      .then(() => {
        this.toggleModal();
        return this.props.dispatch(toggleBanner('addonsDeleteSuccess'));
      })
      .catch(() => {
        this.toggleModal();
        return this.props.dispatch(toggleBanner('addonsDeleteError'));
      });
  }

  addItem () {
    const { dispatch, inventory, addItemForm, addItemId } = this.props;
    const inventoryItems = get(inventory, 'data.inventory');
    const item = filter(inventoryItems, { _id: addItemId }, []);

    const addedItem = {
      title: addItemId,
      count: addItemForm.count,
      unit_cost: addItemForm.unit_cost
    };

    map(Object.keys(item[0]), key => {
      if (!addItemForm[key]) {
        addedItem[key] = item[0][key];
      }
    });

    dispatch(arrayPush(ADD_ITEMS_FORM, 'addOns', addedItem));
    this.toggleModal();
  }

  addAddtlTaxorFee () {
    const { dispatch } = this.props;

    dispatch(submit(ADDTL_TAX_FEES_FORM));
  }

  openModal (whichModal, index) {
    const { dispatch } = this.props;
    this.toggleModal(whichModal);
    // index of the add on is stored so that we know
    // which add on select dropdown to update upon item creation
    dispatch(updateAddOnsIndex(index));
  }

  openEditBookingAddOnModal (itemId, index) {
    const { dispatch } = this.props;

    dispatch(updateAddOnsIndex(index));
    this.toggleModal('editBookingAddOnModal');
  }

  editBookingAddOn () {
    const { dispatch, addItemForm, addOnIndex } = this.props;
    // inititalized the data in add item form and need to dispatch arrayInsert into add items form

    if (addItemForm) {
      dispatch(arrayRemove(ADD_ITEMS_FORM, 'addOns', addOnIndex));
      dispatch(arrayInsert(ADD_ITEMS_FORM, 'addOns', addOnIndex, addItemForm));
      this.toggleModal();
    }
  }

  navigateBack (e) {
    e.preventDefault();
    const { addOnStep, dispatch } = this.props;

    dispatch(updateAddOnsStep(addOnStep - 1));
  }

  redirectToInboxDetails () {
    if (this.props.iosWebView) {
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
      $('#modal-container').modal('hide');
      return this.props.finalCb();
    }

    const bookingId = _.get(this.props, 'booking.booking._id');
    this.context.router.push({ pathname: `/inbox/${bookingId}` });
  }

  closePanel () {
    this.setState({ showAddOnsPanel: false });
  }

  scrollToTop () {
    const modal = document.getElementById('custom-offer-form-modal');
    if (modal) {
      modal.scrollTo(0, 0);
    }
  }

  handleBreadcrumbClick (step) {
    const { maxStepReached, dispatch } = this.props;
    if (maxStepReached >= step) {
      dispatch(updateAddOnsStep(step));
    }
  }

  render () {
    const {
      isFetching,
      inventoryItem,
      booking,
      inventory,
      categories,
      subcategories,
      addItemId,
      addOnStep,
      maxStepReached
    } = this.props;

    const { showAddOnsPanel, whichModal, isVatEnabled } = this.state;
    const fetchedEnvAddOns = !isEmpty(categories) || !isEmpty(subcategories);
    const fetchedBooking = !isEmpty(get(booking, 'booking'));
    const fetchedInventory = !isEmpty(get(inventory, 'data'));
    const isMobile = Helpers.isMobile();
    const fetchedData = fetchedEnvAddOns && fetchedBooking && fetchedInventory;
    const spaceId = get(this.props, 'inventory.item.space_id');

    return (
      <div className={classnames('CustomOfferContainer ps-container-lg-margin ps-container-fixed column', { mobileView: isMobile })}>
        {
          (!isFetching || fetchedData)
            ? <CustomOfferMain
              {...this.props}
              currentStep={addOnStep}
              maxStepReached={maxStepReached}
              createItem={this.createItem}
              deleteItem={this.deleteItem}
              addAddtlTaxorFee={this.addAddtlTaxorFee}
              whichModal={whichModal}
              onModalClose={this.onModalClose}
              openModal={this.openModal}
              getInventoryItem={this.getInventoryItem}
              item={inventoryItem}
              isMobile={isMobile}
              addItemId={addItemId}
              addItem={this.addItem}
              editBookingAddOn={this.editBookingAddOn}
              openEditBookingAddOnModal={this.openEditBookingAddOnModal}
              navigateBack={this.navigateBack}
              redirectToInboxDetails={this.redirectToInboxDetails}
              isEditOffer={this.state.isEditOffer}
              updatePayloadAddOns={this.updatePayloadAddOns}
              showAddOnsPanel={showAddOnsPanel}
              closePanel={this.closePanel}
              toggleModal={this.toggleModal}
              scrollToTop={this.scrollToTop}
              isHostUpdate={this.state.isHostUpdate}
              spaceId={spaceId}
              isVatEnabled={isVatEnabled}
              handleBreadcrumbClick={this.handleBreadcrumbClick}
            />
            : <PageSpinner additionalStyle="gray" />
        }
      </div>
    );
  }
}

CustomOfferContainer.propTypes = {
  accessToken: PropTypes.string,
  isFetching: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  createItemForm: PropTypes.object,
  categories: PropTypes.array,
  subcategories: PropTypes.object,
  inventoryItem: PropTypes.object,
  booking: PropTypes.object,
  inventory: PropTypes.object,
  isMobile: PropTypes.bool,
  addItemId: PropTypes.string,
  openEditBookingAddOnModal: PropTypes.func,
  updateAddOnsStep: PropTypes.func,
  whichModal: PropTypes.string,
  contracts: PropTypes.object,
  payloadData: PropTypes.object,
  routeParams: PropTypes.object,
  bookingId: PropTypes.string,
  isEdit: PropTypes.bool,
  location: PropTypes.object,
  finalCb: PropTypes.func,
  iosWebView: PropTypes.bool,
  profile: PropTypes.object,
  snapshotContracts: PropTypes.object,
  feeProfiles: PropTypes.object,
  addOnStep: PropTypes.number,
  maxStepReached: PropTypes.number
};

CustomOfferContainer.contextTypes = {
  router: PropTypes.object
};

const selector = formValueSelector(ADD_ITEM_FORM);

function mapStateToProps (state, ownProps) {
  const { auth, profile, booking, inventory,
    add_ons, form, env, contract, payload, feeProfiles } = state;

  const {
    isFetching
  } = !isEmpty(inventory.data) || {
    isFetching: true
  };
  const isFetchingInventory = get(inventory, 'isFetching');

  return {
    bookingId: ownProps.bookingID,
    accessToken: auth.accessToken || ownProps.accessToken,
    profile,
    isFetching,
    isFetchingInventory,
    isSubmitting: get(state, 'inventory.isPosting'),
    booking,
    inventory,
    add_ons,
    addOnsForm: form.ADD_ITEMS_FORM,
    createItemForm: form.CREATE_ITEM_FORM,
    addtlTaxFeesForm: form.ADDTL_TAX_FEES_FORM,
    inventoryItem: get(inventory, 'item'),
    categories: get(env, 'addOns.categories'),
    subcategories: get(env, 'addOns.subcategories'),
    addItemId: selector(state, 'title'),
    addItemForm: get(form, 'ADD_ITEM_FORM.values'),
    addOnIndex: get(add_ons, 'index'),
    addOnStep: get(add_ons, 'step'),
    maxStepReached: get(add_ons, 'maxStepReached'),
    payloadData: get(payload, 'data'),
    contract,
    snapshotContracts: get(contract, 'data'),
    feeProfiles
  };
}

export default connect(mapStateToProps)(CustomOfferContainer);
